<template>

  <div>

    <div class="container">

      <div class="row">

        <div class="col-lg-12">

          <h4 class="cart__title">
            Itens do seu Pedido de Orçamento
          </h4>

          <p>
            Selecione a quantidade dos itens desejados e preencha seus dados de contato abaixo que
            retornaremos em breve com uma proposta de orçamento.
          </p>

          <div v-if="cartItemsLength" class="table-responsive">

            <table class="table table-borderless">

              <table-head></table-head>

              <items></items>

            </table>

          </div>

        </div>

      </div>

    </div>

    <customer v-if="cartItemsLength" ref="customer"></customer>

    <div v-if="!cartItemsLength" class="container">
      <div class="row">

        <div class="col-lg-12">
          <div class="alert alert-info">
            Nenhum item adicionado ao pedido de orçamento.
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import * as types from '../store/mutation-types';
  import TableHead from './TableHead.vue';
  import Items from './Items.vue';
  import Customer from './Customer.vue';

  export default {

    name: "Cart",

    props: ['cartItems'],

    components: {
      TableHead,
      Items,
      Customer
    },

    created() {
      this.updateState(this.cartItems);

      bus.$on('cart/saveQuotation', () => {
        this.validateCart();
      });
    },

    mounted() {
      console.log('cart is');
      console.log(this.cartItems);
    },

    methods: {

      ...mapMutations('cart', {
        updateState: types.UPDATE_STATE,
      }),

      ...mapActions('cart', ['saveQuotation']),

      validateCart() {
        this.$validator.validateAll().then(result => {
          if (result) {
            console.log('passou');
            this.saveQuotation();
          } else {
            console.log('NAO passou');
            return this.scrollToFirstError();
          }
        });
      },

      scrollToFirstError() {
        const firstField = Object.keys(this.errors.collect())[0];
        this.$refs.customer.$refs[`cart-${firstField}`].focus();
      },

    },

    computed: {

      ...mapGetters('cart', [
        'cartItemsLength',
      ]),

    },

  }

</script>
